module.exports = __webpack_public_path__ + "static/media/banner8.7d5e13c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner8.png
// module id = 1542
// module chunks = 10